import {defineStore} from 'pinia';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import {ModuleFilterHistory} from '../moduleConst';
import filterHistoryApi from '@/apis/other/filterHistoryApi';
import {useContextStore} from '../contextStore';
import FilterOperator from '@/commons/wildcards/constants/FilterOperator';
import ModelState from '@/commons/wildcards/constants/ModelState';

const filterHistoryStore = new BaseDictionaryStore(filterHistoryApi);

export const useFilterHistoryStore = defineStore(ModuleFilterHistory, {
  state: () => ({
    ...filterHistoryStore.state,
    _config: {
      key: 'filter_history_id',
      table: 'filter_history',
      moduleName: 'Lịch sử bộ lọc',
    },
    moduleName: 'diFilterHistory',
  }),
  actions: {
    ...filterHistoryStore.action,

    /**
     * Custom lại để filter theo user và database
     * @returns
     */
    async getFullListCustom() {
      let contextData = useContextStore().context,
        userId = contextData.user.user_id,
        databaseId = contextData.Context.DatabaseId,
        payload = {};

      let extendFilter = [
        {
          Field: 'user_id',
          Value: userId,
          Operator: FilterOperator.Equals,
        },
      ];

      const config = this._config;
      payload.sort = config.defaultSort ? config.defaultSort : config?.field?.code;
      payload.filter = JSON.stringify(extendFilter);

      return await this.getFullList(payload);
    },

    /**
     * Xử lý trường hợp thêm hoặc update bằng cách gán lại state
     * @param {any} payload
     */
    modifyFilterValue(payload) {
      let checkExist = this.items.findIndex(x => x.filter_history_id == payload.Model.filter_history_id);

      if (checkExist == -1) {
        this.insert(payload);
      } else {
        payload.Model.state = ModelState.Update;
        this.update(payload);
      }
    },
  },
  getters: {
    ...filterHistoryStore.getters,
  },
});
